<template>
  <div class="descriptions-row" :style="{ gridTemplateColumns }">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'DescriptionsRow',
  props: {
    gridTemplateColumns: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="stylus" scoped>
.descriptions-row {
  display: grid;
  grid-template-rows: 1fr;
  column-gap: 10px;
  row-gap: 10px;
}
</style>
